<template>
  <div>
    <el-row type="flex" class="title-bar" justify="space-between">
      <div class="title-h3">소프트웨어 정보</div>
      <div>
        최근 수집시간 : <em>{{checkDatetime}}</em>
        <el-button class="cmp-margin-left" size="small" type="primary" @click="reloadSoftwareInfo()">소프트웨어 정보 갱신</el-button>
        <el-button size="small" @click="exportSoftwareInfo"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper v-loading="isLoading" ref="softwareTable" :data="dataList" :columns="softwareColumns"
    :pagination="false" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showSearchTool" style="width:100%;">
    </el-table-wrapper>
  </div>
</template>

<script>
import moment from 'moment';
import serverInfoAPI from '@/api/config/server/server-info';
import msgUtil from '@/utils/message';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import isNil from 'lodash/isNil';
import { columnDefault } from '@/constants/table';

export default {
  name: 'WSoftwareInfoNode',
  props: {
    activeTab: {
      type: String,
    },
    nodeParams: {
      type: Object,
    },
  },
  data() {
    return {
      columnDefault,
      total: null,
      checkDatetime: null,
      showSearchTool: false,
      dataList: null,
      params: {
        ciInstanceId: null,
        objtypeId: null,
      },
      isLoading: false,
      softwareColumns: [
        {
          prop: 'software',
          label: '소프트웨어',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'vendor',
          label: '게시자',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'installDate',
          label: '설치일',
          width: 300,
          searchType: 'date',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'version',
          label: '버전',
          width: 300,
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  watch: {
    activeTab: {
      handler() {
        this.params.ciInstanceId = this.nodeParams.ciInstanceId;
        this.params.objtypeId = this.nodeParams.objtypeId;
        if (this.activeTab === this.$options.name) {
          this.loadStore();
        }
      },
    },
    nodeParams: {
      handler() {
        this.params.ciInstanceId = this.nodeParams.ciInstanceId;
        this.params.objtypeId = this.nodeParams.objtypeId;
        if (this.activeTab === this.$options.name) {
          this.loadStore();
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * [reloadOSInfo 소프트웨어 정보 갱신]
     * @author yelim
     * @return {[type]}
     */
    reloadSoftwareInfo() {
      const me = this;
      // 소프트웨어 정보 수집을 위해 임의의 값 대입
      if (!isNil(this.nodeParams)) {
        const softwareObj = {
          objId: this.nodeParams.objId,
          ciInstanceId: this.nodeParams.ciInstanceId,
          ipaddressApplytype: this.nodeParams.ipaddressApplytype,
        };
        if (!isNil(this.nodeParams.ipaddressIpv4)) {
          softwareObj.ipaddressIpv4 = this.nodeParams.ipaddressIpv4;
        }
        if (!isNil(me.nodeParams.ipaddressIpv6)) {
          softwareObj.ipaddressIpv6 = this.nodeParams.ipaddressIpv6;
        }

        const target = '소프트웨어 정보 갱신';
        const action = msgUtil.action.RUN;
        serverInfoAPI.executeSoftwareInfo(softwareObj).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            me.loadStore();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      }
    },
    loadStore() {
      const me = this;
      if (this.isLoading === false) {
        this.isLoading = true;
      }
      const tableParams = this.$refs.softwareTable.getParameter();
      const softwareParams = {
        ciInstanceId: this.params.ciInstanceId,
        objtypeId: this.params.objtypeId,
        objId: this.nodeParams.objId,
      };
      const params = Object.assign(tableParams, softwareParams);
      if (!isNil(this.nodeParams.objId) && this.activeTab === this.$options.name) {
        serverInfoAPI.getSoftwareInfoList(params).then((response) => {
          if (response.data.success) {
            me.dataList = response.data.data.data;
            me.checkDatetime = this.checkDatetimeFormatter(response.data.data.checkDatetime);
            this.isLoading = false;
          }
        });
      }
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    exportSoftwareInfo() {
      if (!isNil(this.params.ciInstanceId) && !isNil(this.params.objtypeId)) {
        const softwareParams = {
          ciInstanceId: this.params.ciInstanceId,
          objtypeId: this.params.objtypeId,
          objId: this.nodeParams.objId,
        };
        serverInfoAPI.exportSoftwareInfoList(softwareParams);
      }
    },
    checkDatetimeFormatter(value) {
      return isNil(value) ? EMPTY_TEXT : moment(new Date(value)).format('YYYY-MM-DD HH:mm:ss');
    },
    onTableConditionChange() {
      this.loadStore();
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/config/node/server/software/index.vue